export var errors = {
  unauthorized: new Error('airbrake: unauthorized: project id or key are wrong'),
  ipRateLimited: new Error('airbrake: IP is rate limited')
};